<i18n>
{
  "en": {
    "title": "About Ellipse License Generator version {version}",
    "version": "Version"
  },
  "da": {
    "title": "Omkring Ellipse Licens Generator version {version}",
    "version": "Version"
  }
}
</i18n>

<template>
  <b-modal 
    v-model="display"
    hide-footer 
    :title="title"
    @ok="test"
    size="lg"
    centered 
  >
    <div>
      <div v-for="releasenote in notes.ReleaseNotes" v-bind:key="releasenote.Version">
        {{$t('version')}} {{releasenote.Version}} - {{time(releasenote.Date)}}
        <ul>
          <li v-for="note in releasenote.Notes" v-bind:key="note">
            {{note}}
          </li>
        </ul>
      </div>    
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment'
import elg from '../api/elg.gateway.js'

export default {
  props: [ 'value' ],
  data(){
    return {
      notes: {
        ReleaseNotes: []
      }
    }
  },
  methods: {
    test(){
      console.log("Test!");
    },
    time(val){
      return moment(val).format('YYYY-MM-DD');
    }
  },
  computed: {
    display: {
      get: function(){
        return this.value;
      },
      set: function(value){
        this.$emit('input', value);
      }
    },
    title(){
      //$t('about', { version: })
      var t = this.$i18n.t('title', { version: (this.notes||{}).Version })
      return this.$i18n.t('title', { version: (this.notes||{}).Version })
    }
  },
  mounted(){
    elg()
    .get('/api/v1/server/releasenotes')
    .then( res => {
      this.notes = res.data;
    });
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// WebApp/components/About.vue